<template>
  <div>
    <van-nav-bar title="员工列表" left-text="返回" left-arrow @click-left="onClickLeft" />
    <van-search v-model="value" show-action label="姓名" placeholder="请输入搜索关键词" @search="onSearch">
      <template #action>
        <div @click="onSearch">搜索</div>
      </template>
    </van-search>
    <div style="box-shadow: 0 5px 15px -5px rgba(0,0,0,.5);height: 44px ;line-height: 44px; text-align: center;">
      <van-row type="flex" justify="center">
        <van-col span="6" style="color: #8E2323;">身份证尾号</van-col>
        <van-col span="6" style="color: #8E2323;">姓名</van-col>
        <van-col span="6" style="color: #8E2323;">社保基数</van-col>
        <van-col span="6" style="color: #8E2323;">公积金基数</van-col>
      </van-row>
    </div>
    <div
      v-for="list in listX"
      :key="list.id"
      style="box-shadow: 0 5px 15px -5px rgba(170, 170, 255, 0.5);height: 44px ;line-height: 44px; text-align: center; margin-top: 10px;"
      @click="modify(list)"
    >
      <van-row type="flex" justify="center" style="color:#1196FF">
        <van-col span="6">{{ list.id_card }}</van-col>
        <van-col span="6">{{ list.name | ellipsis }}</van-col>
        <van-col span="6">{{ list.s_base }}</van-col>
        <van-col span="6">
          {{ list.f_base }}
          <van-icon name="ellipsis" style=" position: relative; right: -10px; top: 2px;" />
        </van-col>
      </van-row>
    </div>
    <van-row type="flex" justify="end" style="margin-top:70px;font-size: 14px;color: #CFCFCF;">
      <van-col span="6">共有{{ queryCondition.total }}条数据</van-col>
    </van-row>
    <van-popup v-model="show2" :style="{ height: '30%' }" position="bottom" close-icon="close">
      <van-datetime-picker v-model="currentDate" :min-date="minDate" :max-date="maxDate" type="date" title="选择年月日" @cancel="show2 = false" @confirm="date(currentDate)" />
    </van-popup>
    <van-popup v-model="show3" :style="{ height: '30%' }" position="bottom" close-icon="close">
      <van-datetime-picker
        v-model="currentDate"
        :min-date="minDate"
        :max-date="maxDate"
        type="date"
        title="选择年月日"
        @cancel="show3 = false"
        @confirm="birthdaychange(currentDate)"
      />
    </van-popup>
    <div>
      <van-popup v-model="show" style=" height: 800px; width: 90%">
        <van-form @submit="onSubmit">
          <van-field v-model="timeValue" label="入职时间" @focus="show2 = true" />
          <van-field v-model="clientName" label="所属企业" style="position:relative;" @keyup="client1(clientName, null)" />
          <van-field
            v-model="tel"
            :rules="[{ required: true, message: '请填写您的手机号码！' }, { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误！' }]"
            type="tel"
            label="手机号"
          />
          <van-field v-model="idCard" :rules="[{ validator, message: '请输入正确的身份证号' }]" type="text" label="身份证号" />
          <van-field v-model="Iname" :rules="[{ required: true, message: '请输入姓名' }]" type="text" label="姓名" />
          <van-field v-model="birthday" :rules="[{ required: true, message: '请选择出生日期' }]" label="出生日期" @focus="show3 = true" />
          <van-radio-group v-model="radio" direction="horizontal" style="padding:0 4px;">
            <p style="padding:0 14px;color: #646566;font-size: 14px;line-height: 24px;">性别</p>
            <van-radio name="1">男</van-radio>
            <van-radio name="2">女</van-radio>
          </van-radio-group>
          <van-field v-model="nation" :rules="[{ required: true, message: '请输入民族名称' }]" type="text" label="民族" />
          <!-- <van-field v-model="education" type="text" label="最高学历" /> -->
          <van-collapse v-model="education" :rules="[{ required: true, message: '请选择学历' }]" accordion>
            <van-collapse-item :title="'学历:       ' + xueli" style="color:green;" name="1">
              <span v-for="(item, i) in xl" :key="i" style="cursor: pointer;padding-right: 20px; " @click="educationx(item.name, item.id)">{{ item.name }}</span>
            </van-collapse-item>
          </van-collapse>
          <van-radio-group v-model="political" direction="horizontal" style="padding:0 4px;">
            <p style="padding:0 14px;color: #646566;font-size: 14px;line-height: 24px;">政治面貌</p>
            <van-radio name="1">群众</van-radio>
            <van-radio name="2">党员</van-radio>
          </van-radio-group>
          <van-radio-group v-model="activeName" direction="horizontal" style="padding:0 4px;">
            <p style="padding:0 14px;color: #646566;font-size: 14px;line-height: 24px;">职工身份</p>
            <van-radio name="1">工人</van-radio>
            <van-radio name="2">干部</van-radio>
          </van-radio-group>
          <van-field v-model="number" :rules="[{ required: true, message: '请输入银行卡号！' }]" center clearable label="借记卡号" />

          <van-field v-model="qc.bank_name" is-link center clearable label="银行名称" @focus="bank" />
          <van-collapse v-model="hold_nature" accordion>
            <van-collapse-item :title="'户口性质 :       ' + sf2" style="color:green;" name="1">
              <span v-for="(item, i) in sf" :key="i" style="cursor: pointer;padding-right: 20px; " @click="sfyz(item, i)">{{ item }}</span>
            </van-collapse-item>
          </van-collapse>
          <van-field v-model="addr" :rules="[{ required: true, message: '请输入户籍地址' }]" type="text" label="户籍地址" />
          <van-field v-model="live_addr" :rules="[{ required: true, message: '请输入现住址' }]" type="text" label="现住址" />
          <van-field v-model="mail" :rules="[{ required: true, message: '请输入邮箱' }]" type="text" label="邮箱" />
          <div style="margin: 16px;"><van-button round block type="primary" native-type="submit">提交</van-button></div>
        </van-form>
      </van-popup>
    </div>
    <van-popup v-model="showx" round position="bottom"><van-picker :columns="bank_name" show-toolbar @cancel="showx = false" @confirm="onback" /></van-popup>
    <div>
      <van-tabbar safe-area-inset-bottom>
        <van-pagination v-model="queryCondition.page" :total-items="queryCondition.total" :show-page-size="4" force-ellipses @change="query()" />
      </van-tabbar>
    </div>
  </div>
</template>

<script>
import { Wxlist, Wxmodify } from '@/api/Hremployee';
import { ClientList } from '@/api/Hrclient';
import { WxSocList, WxSocmodify } from '@/api/Hrfund';
import { billadd } from '@/api/Hrbill';

import { Toast } from 'vant';
export default {
  name: 'EmpList',
  filters: {
    ellipsis(value) {
      if (!value) return '';
      if (value.length > 6) {
        return value.slice(0, 6) + '...';
      }
      return value;
    }
  },
  props: {
    qc: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      vancol: '',
      activeName: '',
      show: false,
      client: false,
      bank_namex: '',
      Iname: '',
      nation: '',
      value: '',
      education: '',
      political: '0',
      hold_nature: '',
      addr: '',
      live_addr: '',
      mail: '',
      clientName: '',
      text: '',
      phone: '',
      idCard: '',
      tel: '',
      password: '',
      number: '',
      sms: '',
      menu: [],
      Menux: [],
      children: [],
      childrenc: [],
      minDate: new Date(1960, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      timeValue: '请选择时间',
      show2: false,
      show3: false,
      birthday: '请选择出生日期',
      radio: '1',
      list: [],
      list2: [],
      loading: false,
      finished: false,
      queryCondition: {
        total: this.CONST.PAGINATION.TOTAL,
        page: this.CONST.PAGINATION.PAGE,
        rows: this.CONST.PAGINATION.ROWS,
        sort: 'id',
        order: 'desc',
        client_name: '',
        name: ''
      },

      listX: [],
      clientx: 0,
      xueli: '',
      xl: [
        { id: 791, name: '初中及以下' },
        { id: 792, name: '高中' },
        { id: 792, name: '高中' },
        { id: 793, name: '专科' },
        { id: 794, name: '本科' },
        { id: 795, name: '硕士' },
        { id: 796, name: '博士' }
      ],
      sf: ['外埠城镇', '外埠农村', '本市城镇', '本市农村'],
      sf2: '',
      emp: [
        {
          client_id: 0,
          clientName: ''
        }
      ],
      xul: 0,
      id: 0,
      educationX: 0,
      bank_name: [],
      showx: false,
      client_id: 0,
      status: 0,
      list1: [],
      vanlist: false
    };
  },
  mounted() {
    this.query();
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    bank() {
      if (this.number.length <= 4) {
        Toast.fail('请输入正确的银行卡号');
      } else {
        this.showx = true;
        this.sys();
      }
    },
    sys() {
      this.axios
        .post('/sys-dictionaries/list', {
          token: sessionStorage.getItem('token'),
          rows: 2000
        })
        .then(res => {
          const length = res.data.rows.length;
          for (let i = 0; i < length; i++) {
            if (res.data.rows[i].type === 32) {
              this.bank_name.push(res.data.rows[i].name);
            }
          }
        });
    },
    onback2() {
      this.showx = true;
    },
    onback(value) {
      this.bank_namex = value;
      this.showx = false;
      this.qc.bank_name = value;
    },
    birthdaychange(val) {
      const year = val.getFullYear();
      let month = val.getMonth() + 1;
      let day = val.getDate();
      let hour = val.getHours();
      let minute = val.getMinutes();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`;
      }
      if (hour >= 0 && hour <= 9) {
        hour = `0${hour}`;
      }
      if (minute >= 0 && minute <= 9) {
        minute = `0${minute}`;
      }
      this.birthday = `${year}-${month}-${day}`;
      this.show3 = false;
    },
    onSearch() {
      this.query();
    },
    client1(value, value1) {
      // 清除延迟执行
      // this.list = [];
      // 设置延迟执行
      this.list = [];
      this.list1 = [];
      this.list2 = [];
      this.yy1 = '';
      this.ax();
    },
    ax() {
      if (this.clientName !== null && this.clientName.length !== 0) {
        setTimeout(() => {
          this.axios
            .post('/client/dict', {
              name: this.clientName,
              token: sessionStorage.getItem('token')
            })
            .then(res => {
              const len = res.data.rows.length;
              if (len > 0) {
                this.vanlist = true;
              }
              for (let i = 0; i < len; i++) {
                this.list1.push({ id: res.data.rows[i].id, name: res.data.rows[i].name });
              }
              this.loading = false;
              // 数据全部加载完成
              if (this.list1.length >= len) {
                this.finished = true;
              }
            });
        }, 500);
      }
    },

    educationx(value, value1) {
      this.xueli = value;
      this.education = '0';
      this.xul = value1;
    },
    sfyz(value, value1) {
      this.sf2 = value;
      this.hold_nature = '0';
    },
    date(val) {
      const year = val.getFullYear();
      let month = val.getMonth() + 1;
      let day = val.getDate();
      let hour = val.getHours();
      let minute = val.getMinutes();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`;
      }
      if (hour >= 0 && hour <= 9) {
        hour = `0${hour}`;
      }
      if (minute >= 0 && minute <= 9) {
        minute = `0${minute}`;
      }
      this.timeValue = `${year}-${month}-${day}`;

      this.show2 = false;
    },
    modify(val) {
      this.show = true;
      ClientList({ client_id: parseInt(val.client_id) }).then(res => {
        this.clientName = res.rows[0].name;
      });
      WxSocList({ emp_id: val.id }).then(res => {
        this.number = res.rows[0].card_no;
        this.qc.bank_name = res.rows[0].bank_name;
      });
      Wxlist({ id: val.id }).then(res => {
        const resx = res.rows[0];
        this.Iname = resx.name;
        this.timeValue = resx.entry_date;
        this.tel = resx.phone;
        this.idCard = resx.id_card;
        this.birthday = resx.birthday;
        this.radio = resx.sex.toString();
        this.nation = resx.nation;
        this.addr = resx.addr;
        this.live_addr = resx.live_addr;
        this.mail = resx.mail;
        this.client_id = resx.client_id;
        this.qc.number = resx.card_no;
        this.bank_namex = resx.bank_name;
        this.activeName = resx.emp_quality ? resx.emp_quality.toString() : '0';
        this.sf2 = resx.hold_nature;
        this.political = resx.political ? resx.political.toString() : '0';
        this.qc.emp_id = resx.id;
        this.status = resx.status;
        this.qc.s_base = resx.s_base ? resx.s_base : -1;
        this.sf2 = resx.hold_nature;

        if (resx.emp_quality != undefined) {
          this.activeName = resx.emp_quality.toString();
        }
        for (let i = 0; i < this.xl.length; i++) {
          if (val.education === this.xl[i].id) {
            this.xueli = this.xl[i].name;
            this.educationX = this.xl[i].id;
          }
        }
      });
    },
    onSubmit() {
      Wxmodify({
        name: this.Iname,
        entry_date: this.timeValue,
        phone: this.tel,
        id_card: this.idCard,
        birthday: this.birthday,
        sex: parseInt(this.radio),
        nation: this.nation,
        addr: this.addr,
        live_addr: this.live_addr,
        mail: this.mail,
        client_id: parseInt(this.client_id),
        hold_nature: this.sf2,
        emp_quality: parseInt(this.activeName),
        political: parseInt(this.political),
        emp_id: this.qc.emp_id,
        education: this.educationX
      }).then(res => {
        if (res.success) {
          WxSocmodify({
            card_no: this.number,
            bank_name: this.bank_namex,
            emp_id: this.qc.emp_id
          });
          if (this.status === 1 && this.qc.s_base >= 0) {
            billadd({
              emp_id: this.qc.emp_id,
              client_id: parseInt(this.client_id),
              id_card: this.idCard,
              type: '社保-员工修改',
              addr: this.addr,
              hold_nature: this.sf2,
              card_no: this.number,
              bank_name: this.bank_namex,
              status: 6,
              create_id: parseInt(sessionStorage.getItem('create_id')),
              check_type: 2
            });
          }

          this.show = false;
          this.toast(res.msg);
          this.query();
        } else {
          this.toast(res.msg);
        }
      });
    },
    validator(val) {
      const reg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/;
      if (!reg.test(val)) {
        return false;
      } else {
        return true;
      }
    },
    query() {
      this.listX = [];
      console.log(this.value ? this.value : null);
      Wxlist({
        name: this.value ? this.value : null,
        client_id: parseInt(sessionStorage.getItem('client_id')),
        total: this.queryCondition.total,
        page: this.queryCondition.page,
        rows: 10
      }).then(res => {
        const len = res.rows.length;
        const rox = res.rows;

        for (let i = 0; i < len; i++) {
          this.listX.push({
            id: rox[i].id,
            name: rox[i].name,
            id_card: rox[i].id_card !== undefined ? rox[i].id_card.toString().substr(-4) : '暂无',
            f_base: rox[i].f_base !== undefined ? rox[i].f_base : '暂无',
            s_base: rox[i].s_base,
            client_id: rox[i].client_id,
            education: rox[i].education
          });
        }
        this.queryCondition.total = res.total || 0;
      });
    }
  }
};
</script>

<style scoped>
.van-tabbar--fixed >>> .van-pagination {
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/hr/employee/emp-list.vue